















































import AbpBase from "@/lib/abpbase"
import Type from './types'
import {
	Component,
	Prop, Watch
} from "vue-property-decorator"
import {EditPatientOutCome, InsertPatientOutCome} from "@/api/patient"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any
	model: any = {
		type: '转归',
		typeReason:'血透',
		isDeleteBedPlan:false
	}
	Type = new Type()

	created() {
		if (this.data.mode === 'edit') {
			this.model = this.data.item
		}
	}

	save() {
		(this.$refs.form as any).validate(async (valid: boolean) => {
			if (valid) {
				console.log(this.model)
				let res
				if (this.data.mode === 'add') {
					this.model.patientId = this.data.patient.id
					res = await InsertPatientOutCome(this.model)
				} else {
					res = await EditPatientOutCome(this.model)
				}
				if (res.status === 1) {
					this.$emit('save-success')
				}
			}
		})
	}
	@Watch('model.type')
	typeChange(){
		if (this.model.type === '转回') {
			this.model.typeReason = '转回中心'
		} else if (this.model.type === '转归') {
			this.model.typeReason = '血透'
		}
	}

	get modalTitle() {
		return this.data.mode === 'add' ? '新增转归' : '编辑转归'
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	cancel() {
		this.$emit('input', false);
	}

	rules = {
		inputDate: [{
			required: true,
			message: '请选择日期',
		}],
		dialysisModelCode: [{
			required: true,
			message: '请选择模式',
			trigger: 'blur'
		}],
		colorEnum: [{
			required: true,
			message: '请输入内容',
			trigger: 'blur'
		}],
		flagEnum: [{
			required: true,
			message: '请输入内容',
			trigger: 'blur'
		}],
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/outCome/addOrEdit.vue